import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import context from './main'

import { getToken, clearLoginData } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

const whiteList = ['/','/index','/apply', '/login', '/receive'] // 不重定向白名单
router.beforeEach((to, from, next) => { // beforeEach是router的钩子函数，在进入路由前执行
  
  NProgress.start()
  if (window.gtag) {
    gtag('config', 'G-PXC7VNNEXF', {'page_path': to.fullPath});
  }
 
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title
  }
  if (to.name === 'tcIndex') {
    next({path: `/index`, replace: true})
    NProgress.done()
  } else if (to.name === 'tcApply') {
    next({path: `/apply`, replace: true})
    NProgress.done()
  } else if (to.name === 'tcInvite') {
    next({path: `/receive?id=${to.params.id}&code=${to.params.code}`, replace: true})
    NProgress.done()
  } else if (to.name === 'tcTeam') {
    next({path: `/team`, replace: true})
    NProgress.done()
  } else if (to.name === 'tcGrade') {
    next({path: `/score`, replace: true})
    NProgress.done()
  }   else if (getToken()) {
    store.dispatch('GetLocalUserInfo')
    if (to.path == 'login') {
        next('/index')
        NProgress.done()
    } else {
        next()
    } 
  } else {
    clearLoginData()
    if (whiteList.indexOf(to.path) !== -1) {
        next()
    } else {
        if (context) {
          context.$createToast({
            txt: '请先登录',
            type: 'txt'
          }).show();
          setTimeout(() => {
              next(`/login?redirect=${to.path}`)
          } , 1000)
        } else {
          next(`/login?redirect=${to.path}`)
        }
        
        
        
        NProgress.done()
    }
  }  

  router.afterEach(() => {
    NProgress.done() // 结束Progress
  })
})
